<script lang="ts">
  import DesktopMenu from '$lib/components/common/menu/DesktopMenu.svelte'
  import { storeHeroMenu } from '$lib/js/stores';
  import { page } from '$app/state';
	import { is_set_array } from '$lib/js/helpers';

	let menu_levels = page.data.menu_levels
  let firstLevel = menu_levels.firstLevel
  let secondLevel = menu_levels.secondLevel
  let thirdLevel = menu_levels.thirdLevel
</script>

{#if $storeHeroMenu && is_set_array(menu_levels.firstLevel)}
  <div class="desktop-menu">
    <DesktopMenu {firstLevel} {secondLevel} {thirdLevel} />
  </div>
{/if}

<style lang="scss">
  .desktop-menu {
    @media (max-width: 1024px) {
      display: none;
    }
  }
</style>
